export default "__VITE_ASSET__CCjVY06q__"